export const START_BULK_UPLOAD_TO_SERVER = 'START_BULK_UPLOAD_TO_SERVER';
export const STOP_BULK_UPLOAD_TO_SERVER = 'STOP_BULK_UPLOAD_TO_SERVER';
export const RESET_BULK_UPLOAD_TO_SERVER = 'RESET_BULK_UPLOAD_TO_SERVER';
export const START_FILE_UPLOAD_TO_SERVER = 'START_FILE_UPLOAD_TO_SERVER';
export const ERROR_IN_FILE_UPLOADING_TO_SERVER = 'ERROR_IN_FILE_UPLOADING_TO_SERVER';
export const SUCCESSFULLY_FILE_UPLOADED_TO_SERVER = 'SUCCESSFULLY_FILE_UPLOADED_TO_SERVER';
